var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingState.bracket)?_c('loader'):(_vm.hasBracket)?_c('div',{ref:"bracket"},[_c('div',{staticClass:"bracket-view"},[(_vm.bracketType)?_c(_vm.bracketType,{tag:"component",attrs:{"tournament-id":_vm.id,"rounds":_vm.rounds}}):_vm._e()],1)]):_c('p',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.$t('tournaments.placeholders_bracket'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }